<template>
  <div v-if="loading">
    Loading Postechs from store...
  </div>
  <div v-else>
    <div class="debug">
        <p>header = {{ header }}</p>
        <p>tableData.length = {{ tableData.length }}</p>
        <p>colWidths = {{ colWidths }}</p>
        <p>filtered.length = {{ filtered.length }}</p>
        <p>search = {{ search }}</p>
    </div>
  <FilterTable 
    :header="header"
    :data="postechTableData"
    :columnWidths="colWidths"
    :allowDownload="currentGroup === 'admin' || currentGroup === 'standard'"
    @rowClicked="printRow"
    v-model:filtered="filtered"
    v-model:search="search"
  >
  </FilterTable>

  <!--div class="btn-row-left">
    <FormBtn :name="'Refresh Table'" @clicked="postechs.fetchAllPostech"></FormBtn>
  </div-->
  </div>
 

  <!--div class="debug">
        <p>header = {{ header }}</p>
        <p>allPostech.length = {{ allPostech.length }}</p>
        <p>colWidths = {{ colWidths }}</p>
        <p>filtered.length = {{ filtered.length }}</p>
        <p>search = {{ search }}</p>
    </div>-->
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
//import { loadingStart, loadingEnd } from '../js/common.js';
//import MyTable from '@/components/MyTable.vue';
import * as yup from 'yup'

import { usePostechStore, useUserStore } from '@/stores'
import { FormBtn } from '@/components/form'
//import { useCustomerTableFilter } from '@/composables/Customer-table-filter';
import { usePostechTableFilter } from '@/composables/Postech-table-filter';
import type { Postech } from '@/types/types'
import { useAllCsvDownload } from '@/composables/All-csv-download'
import { postechPileSchema } from '@/types/types'
import router from '@/router'
import { FilterTable } from '@/components'
import { storeToRefs } from 'pinia'

const postechs = usePostechStore()
const userStore = useUserStore()
const { currentGroup } = storeToRefs(userStore)
const { tableData } = storeToRefs(postechs);
//const allPostech = ref<Array<Postech>>([])
const header = ['id', 'projectId', 'pileCount', 'installer'] //, "companyName", "invoiceName", "email"];
const colWidths = [70]

const postechTableData = computed(()=>{
  return JSON.parse(JSON.stringify(tableData.value));
})

const postechSchema = yup.object({
  id: yup.number(),
  created_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), //Date
  created_by: yup.string().nullable(), // string
  modified_on: yup
    .date()
    .nullable()
    .min(new Date(2020, 0, 1)), // Date
  projectId: yup.number().defined(),
  //installer: customerSchema.defined(),
  installer_id: yup.number().defined(),
  pilesSupporting: yup.string().nullable(),
  pileLoads: yup.mixed().oneOf(['Loads Calculated', 'Loads Provided by Others', '']).nullable(),
  //stage?: string
  piles: yup.array().of(postechPileSchema).nullable() //.defined().min(1)
})

const postechHeader = [
  'id',
  'created_on',
  'created_by',
  'modified_on',
  'projectId',
  'installer_id',
  'pilesSupporting',
  'pileLoads',
  'piles'
]



//await getPostechs()

const loading = computed(()=>{
  return postechs.loading;
})
//const filteredCustomers = ref(allCustomers.value);
let searchJson = {}
header?.forEach((col) => {
  searchJson[col] = ''
})
const search = ref(searchJson)
//const { filtered } = useCustomerTableFilter(allCustomers.value, search);
const { filtered } = usePostechTableFilter(postechTableData, search);
/*
const { downloadAllCsv } = useAllCsvDownload(
  postechTableData,
  postechSchema,
  postechHeader,
  'Postech'
)

async function downloadAllPostech(){
  await postechs.fetchAllPostech();
  await downloadAllCsv();
}
*/


/*
async function forceFetchPostechs(){
  console.log("Postech-table.forceFetchPostechs...");
  await postechs.fetchAll();
  //const mapped = await parseTableData(data);
 // allPostech.value = mapped;
}*/

/*
async function getPostechs() {
  console.log('Postech-table.getPostech()...')
  const data = await postechs.getAll();
  const mapped = await parseTableData(data);
  allPostech.value = mapped;
}*/
/*
async function parseTableData(data : Array<Postech>){
  console.log(".. parseTableData for Postech...");
    //map array to show customer fields
   const mapped = await Promise.all(data.map(async (postech) => {
    //inv.customerName = inv.customer.invoiceName;
    //console.log('... piles = ' + JSON.stringify(postech.piles))
    try{
      const totalPiles = sumField(postech.piles, 'pileCount')
      postech.pileCount = totalPiles
    }catch(error){
      console.error("..trapped error on totalPiles parseTable = " + error);
      console.log("..postech = " + postech.id);
    }
    //const totalPiles = 99;
    let installer;
    try{
     installer = postech.installer.invoiceName;
     postech.installer = installer;
    }catch(error){
      console.error("..trapped error Postech-table.setPostechs() error fetching postech on installer: " + error);
      console.error("...postech obj = " + JSON.stringify(postech));
      postech.installer = "undefined in backend";
    }
    return postech
  }))

  return mapped;
}*/


//const emit = defineEmits(['navigate']);

function printRow(item: Postech) {
  console.log('printRow..')
  console.log(JSON.stringify(item))
  //console.log("...pushing router to project_details");
  let projectId = item.projectId
  router.push(`/projects/${projectId.toString()}/postech/${item.id?.toString()}`)
}
/*
  function downloadAllPostech(){
    console.log("postech table . download all postech...");
  }
  
 */
</script>
